<template>

	<button  type="button" class="button solid small accent" v-on:click="toggleAddonPopup()" style="justify-self: start;"  :style="'--accent:' + this.accent">
		<span class="fa-stack fa-1x">
			<i class="fal fa-circle fa-stack-2x"></i>
			<i class="fas fa-plus fa-stack-1x"></i>
		</span>
		{{ addon_count == 1 ? 'Add another activity' : 'Add more activities' }}
	</button>

</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'uuid',
		'accent',
		'addon_count'
	],

	data: () => {
		return {
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
	},

	methods: {

		toggleAddonPopup: function(){
			this.$root.$refs.addons.toggleAddonPopup(this.uuid);
		}

	}
};
</script>